<template>
  <div v-if="resFeeApplicable
            && resDetails.userInfo.paymentReceipt
            && resDetails.userInfo.paymentReceipt.authorizationNumber" class="payment-receipt">
    <h2>Payment receipt</h2>
    <div class="payment-items">
      <div>
        <div>Customer ID</div>
        <div class="desc">{{ resDetails.userInfo.customerCid }}</div>
      </div>
      <div>
        <div>Name on card</div>
        <div class="desc">
          {{ resDetails.userInfo.paymentReceipt.paymentMakerFirstName }}
          {{ resDetails.userInfo.paymentReceipt.paymentMakerLastName }}
        </div>
      </div>
      <div>
        <div>Date paid</div>
        <div class="desc">{{ paymentDate }}</div>
      </div>
      <div>
        <div>Authorization number</div>
        <div class="desc">{{ resDetails.userInfo.paymentReceipt.authorizationNumber }}</div>
      </div>
      <div>
        <div>Fee name</div>
        <div class="desc">{{ resDetails.userInfo.paymentReceipt.feeName }}</div>
      </div>
      <div>
        <div>Total amount paid</div>
        <div class="desc">{{ toCurrency(resDetails.userInfo.paymentReceipt.authorizationAmount) }}</div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { parseISO } from 'date-fns';
import format from 'date-fns/format'
import { toCurrency } from '../../../utils/globalFilters';

//  Vuex store
const store = useStore();

// Computed properties 
const resDetails = computed(() => store.state.user.resDetails);
const resFeeApplicable = computed(() => store.state.user.resFeeApplicable);

/**
 * Formats payment date in client's local time, i.e. not converting to ET for simplicity.
 * @returns {string|*|string}
 */
const paymentDate = computed(() => {
  const paid = (resDetails.value?.userInfo?.paymentReceipt)
    ? resDetails.value.userInfo.paymentReceipt.feePaidDate
    : undefined;

  let tmp = paid;
  if (tmp && (typeof tmp === 'string')) {
    tmp = parseISO(paid);
  }

  return tmp ? format(tmp, 'MMMM d, yyyy') : 'Unknown';
});
</script>


<style lang="scss" scoped>
.payment-receipt {
  margin: 0.5em 0 1.5em;
  .payment-items {
    border-top: 1px solid var(--ri-gray);
    border-bottom: 1px solid var(--ri-gray);
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1em;
    padding: 1em 0;
    margin-top: 1em;
    .desc {
      @extend %font-sans-bold;
    }
  }
  @media print {
    margin: -1em 0 0;
  }
}
</style>
